export default (theme) => ({
  notifications: {
    zIndex: 9999,
    position: 'fixed',
    top: theme.spacing(3),
    right: theme.spacing(3),
  },
});
